import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from './PublicHeader';

export default function PublicLayout() {
  return (
    <div>
      <PublicHeader />
      <main style={{ maxWidth: 1200, margin: '0 auto', padding: '1.5rem 1.25rem' }}>
        <Outlet />
      </main>
    </div>
  );
}
